import { COLOR } from "../../themes";
const CopyIcon = ({ color = COLOR.GOLD_1 }) => (
  <svg
    width="28"
    height="18"
    viewBox="0 0 18 18"
    fill={color}
    stroke={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 11.4615C17 11.9512 16.8055 12.4207 16.4593 12.767C16.1131 13.1132 15.6435 13.3077 15.1538 13.3077H13.3077V12.0769H15.1538C15.3171 12.0769 15.4736 12.0121 15.589 11.8967C15.7044 11.7813 15.7692 11.6247 15.7692 11.4615V2.84615C15.7692 2.68294 15.7044 2.52642 15.589 2.41101C15.4736 2.2956 15.3171 2.23077 15.1538 2.23077H6.53846C6.37525 2.23077 6.21873 2.2956 6.10332 2.41101C5.98791 2.52642 5.92308 2.68294 5.92308 2.84615V4.69231H11.4615C11.9512 4.69231 12.4207 4.88681 12.767 5.23303C13.1132 5.57925 13.3077 6.04883 13.3077 6.53846V15.1538C13.3077 15.6435 13.1132 16.1131 12.767 16.4593C12.4207 16.8055 11.9512 17 11.4615 17H2.84615C2.35652 17 1.88695 16.8055 1.54072 16.4593C1.1945 16.1131 1 15.6435 1 15.1538V6.53846C1 6.04883 1.1945 5.57925 1.54072 5.23303C1.88695 4.88681 2.35652 4.69231 2.84615 4.69231H4.69231V2.84615C4.69231 2.35652 4.88681 1.88695 5.23303 1.54073C5.57925 1.1945 6.04883 1 6.53846 1H15.1538C15.6435 1 16.1131 1.1945 16.4593 1.54073C16.8055 1.88695 17 2.35652 17 2.84615V11.4615ZM12.0769 6.53846C12.0769 6.37525 12.0121 6.21873 11.8967 6.10332C11.7813 5.98791 11.6247 5.92308 11.4615 5.92308H2.84615C2.68294 5.92308 2.52642 5.98791 2.41101 6.10332C2.2956 6.21873 2.23077 6.37525 2.23077 6.53846V15.1538C2.23077 15.3171 2.2956 15.4736 2.41101 15.589C2.52642 15.7044 2.68294 15.7692 2.84615 15.7692H11.4615C11.6247 15.7692 11.7813 15.7044 11.8967 15.589C12.0121 15.4736 12.0769 15.3171 12.0769 15.1538V6.53846Z"
      fill={color}
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default CopyIcon
